<ng-template #clipboardButtonTemplate>
    <button matIconButton type="button" (click)="copyToClipboard()"
        aria-label="Copy code to clipboard">
        <mat-icon class="material-symbols-outlined icon-sm" aria-hidden="true"
            fontIcon="integration_instructions" />
    </button>
</ng-template>

@for (block of thoughtBlocks(); track $index) {
  <details class="ai-meta-block">
    <summary aria-label="Toggle thought process">
      <mat-icon class="ai-meta-icon icon-xsm" aria-hidden="true">psychology</mat-icon>
      <span>Thought process</span>
    </summary>
    <div class="ai-meta-content">
      <markdown [data]="block"></markdown>
    </div>
  </details>
}

@for (block of toolUseBlocks(); track $index) {
  <details class="ai-meta-block">
    <summary aria-label="Toggle tool use">
      <mat-icon class="ai-meta-icon icon-xsm" aria-hidden="true">build</mat-icon>
      <span>Tool use</span>
    </summary>
    <div class="ai-meta-content">
      <markdown [data]="block"></markdown>
    </div>
  </details>
}

@for (block of toolResultBlocks(); track $index) {
  <details class="ai-meta-block">
    <summary aria-label="Toggle tool result">
      <mat-icon class="ai-meta-icon icon-xsm" aria-hidden="true">output</mat-icon>
      <span>Tool result</span>
    </summary>
    <div class="ai-meta-content">
      <markdown [data]="block"></markdown>
    </div>
  </details>
}

<markdown clipboard [clipboardButtonTemplate]="clipboardButtonTemplate" [data]="mainContent()"></markdown>
